export const FILTER_SETS_CELLS = {
  NAME_CELL: 'name_cell',
  VIEW_CELL: 'view_cell',
  TAEGET_CELL: 'target_cell',
  OWNER_CELL: 'owner_cell',
  ACTIONS_CELL: 'actions_cell'
};
